import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VApp, [_vm.token ? _c(VForm, {
    ref: "form",
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "lazy-validation": ""
    },
    model: {
      value: _vm.valid,
      callback: function ($$v) {
        _vm.valid = $$v;
      },
      expression: "valid"
    }
  }, [_c(VContainer, {
    class: _vm.loginContainerStyle(),
    attrs: {
      "fluid": ""
    }
  }, [!_vm.isDefaultSvgLogo() ? _c('core-logo-custom', {
    attrs: {
      "image": _vm.loginLogo.image,
      "orientation": _vm.loginLogo.orientation
    }
  }) : _vm._e(), _c('div', {
    staticClass: "dsuite-panel",
    style: _vm.getBG()
  }, [_vm.isDefaultSvgLogo() ? _c(VRow, {
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c(VCol, {
    staticClass: "pa-0",
    attrs: {
      "cols": "12",
      "align": "center"
    }
  }, [_c(VSheet, {
    staticClass: "mx-auto dsuite-dgmnd-logo dsuite-login-bg"
  }, [_c('core-logo-niotix', {
    attrs: {
      "width": "100",
      "color": "#00A9E1",
      "dark": _vm.UiTheme
    }
  })], 1)], 1)], 1) : _vm._e(), _c(VRow, {
    staticClass: "fill-height",
    staticStyle: {
      "margin-top": "-40px !important"
    },
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c(VCol, {
    staticClass: "text-center px-12",
    attrs: {
      "cols": "12",
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "mx-auto",
    staticStyle: {
      "max-width": "800px"
    }
  }, [_c(VRow, {
    attrs: {
      "align": "center"
    }
  }, [_c(VCol, {
    staticClass: "pb-10",
    attrs: {
      "cols": "12",
      "align": "left"
    }
  }, [_c('h1', {
    staticClass: "mobile-headline",
    staticStyle: {
      "color": "#fff",
      "margin-bottom": "-60px"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('accMgmt.user.changePassword')) + "\n                  ")])]), _c(VCol, {
    staticClass: "pt-10 pb-0",
    attrs: {
      "cols": "12",
      "md": "5",
      "lg": "5"
    }
  }, [_c('core-password-field', {
    attrs: {
      "rules": _vm.passwordRules,
      "label": _vm.$i18n_t('accMgmt.user.newPwd'),
      "filled": "",
      "outlined": false,
      "background-color": _vm.themeGetBgColors(),
      "error-messages": _vm.passwordError,
      "error": _vm.passwordHasError,
      "name": "NewPassword",
      "autocomplete": "off",
      "required": ""
    },
    model: {
      value: _vm.password,
      callback: function ($$v) {
        _vm.password = $$v;
      },
      expression: "password"
    }
  })], 1), _c(VCol, {
    staticClass: "pt-10 pb-0",
    attrs: {
      "cols": "12",
      "md": "5",
      "lg": "5"
    }
  }, [_c('core-password-field', {
    attrs: {
      "rules": _vm.passwordConfirmRules,
      "label": _vm.$i18n_t('accMgmt.user.repeatPwd'),
      "filled": "",
      "outlined": false,
      "background-color": _vm.themeGetBgColors(),
      "name": "NewPassword2",
      "autocomplete": "off",
      "required": ""
    },
    model: {
      value: _vm.passwordConfirm,
      callback: function ($$v) {
        _vm.passwordConfirm = $$v;
      },
      expression: "passwordConfirm"
    }
  })], 1), _c(VCol, {
    staticClass: "pb-0",
    staticStyle: {
      "padding-top": "11px"
    },
    attrs: {
      "cols": "1"
    }
  }, [_c(VBtn, {
    staticClass: "elevation-0",
    staticStyle: {
      "border-radius": "4px",
      "height": "55px"
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.valid || _vm.$store.state.app.loading,
      "color": _vm.themeGetBgColors()
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('accMgmt.user.changePassword')) + "\n                  ")])], 1)], 1)], 1)])], 1)], 1)], 1)], 1) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };